<template>
    <CardRh :processando="processando">
        <div class="qts-semanal-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-4">
                        <label for="searchQtsSemanal" class="form-label">Pesquisar</label>
                        <input id="searchQtsSemanal" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Descrição" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-8 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="hasPermissaoEditar" type="button" class="btn btn-sm btn-pmes-primary"
                            title="Cadastrar" data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                            <span class="menu-icon">
                                <i class="fa fa-plus fa-2x bi"></i>
                            </span>
                            Cadastrar Novo QTS Semanal
                        </button>
                    </div>
                </div>

                <Cadastro :turma="turma" @qts-semanal-alterado="refreshTable" :modal="modal_cadastro" :perfis="perfis" />
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:90px">ID</th>
                    <th>Descrição</th>
                    <th>Período</th> 
                    <th class="text-center">Status</th>
                    <th class="text-center">Observação</th>
                    <th style="min-width:310px" class="text-center" v-if="hasPermissao">Ações</th>
                </KDataTable>
            </section>
        </div>

        <Editar @qts-semanal-alterado="modeloAlterado" :turma="turma" :modelo="dados" :modal="modal_atualizar"
            v-if="hasPermissaoEditar" :perfis="perfis" />

        <Duplicar :modal="modal_duplicar" :perfis="perfis" :modelo="dadosDuplicar"
            v-if="hasPermissaoEditar" @qts-duplicado="aoDuplicado" />
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";
import { Options } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import Duplicar from "./_Duplicar.vue";
import { labelStatusQts } from "./constantes";

@Options({
    name: "QtsSemanalIndex",
    components: { CardRh, KDataTable, Cadastro, Editar, Duplicar },
})
export default class QtsSemanalIndex extends IndexModelTable {
    @Prop() readonly turma!: any

    public turmaId: any = null;
    public search = '';
    public modal_duplicar = 'modal_qts_semanal_duplicar';
    public dadosDuplicar: any = null;

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => { this.reloadDatatable = !this.reloadDatatable; }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) { this.refreshTable(); }
    }

    public limparFiltros() {
        this.search = '';
        this.refreshTable();
    }

    private fmtData(v: any) {
        if (!v) return '';
        const s = String(v).substring(0, 10);
        const p = s.split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
    }

    created() {
        this.service = new QtsSemanalService();
        this.turmaId = this.$route.params.id;
        this.modal_atualizar = 'modal_qts_semanal_update';

        this.config.order = [[0, 'desc']];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                return {
                    Skip: d.start,
                    Take: d.length,
                    turmaId: this.turmaId,
                    search: this.search || d.search.value,
                };
            }
        };

        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'descricao', name: 'descricao' },
            { data: 'inicio', name: 'inicio', orderable: false, searchable: false }, 
            { data: 'status', name: 'status', class: 'text-center' },
            { data: 'observacao', name: 'observacao', class: 'text-center' },
        ];

        this.config.columnDefs = [
            {
                targets: 2,
                render: (row, type, full) => {
                    const ini = this.fmtData(full.inicio);
                    const fim = this.fmtData(full.fim);
                    return ini || fim ? `${ini} a ${fim}` : '-';
                },
            },
            {
                targets: 3,
                render: (row) => labelStatusQts(row),
            },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 5,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) { buttom = buttom + ' data-' + key + '="' + val[key] + '"'; }
                        texto += '<button class="btn btn-pmes-primary btn-sm" btn-ver ' + buttom + ' title="Detalhes"><i class="fa fa-eye"></i></button>';
                        if (this.hasPermissaoEditar) {
                            texto += '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                                this.modal_atualizar + '" title="Editar"><i class="fa fa-edit"></i></button>';
                            texto += '<button class="btn btn-light-pmes-dark-primary border border-pmes-dark-primary btn-sm" btn-duplicar ' + buttom +
                                ' data-bs-toggle="modal" data-bs-target="#' + this.modal_duplicar + '" title="Duplicar"><i class="fa fa-copy"></i></button>';
                            texto += '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + ' title="Excluir"><i class="fa fa-trash"></i></button>';
                        }
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $('[btn-ver]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.$router.push({ name: 'sigap_turma_qts_gerador_qtssemanal_show', params: { id: this.turmaId, qtsSemanalId: id } });
        });
        $('[btn-editar]').click((btn) => {
            this.dados = null;
            setTimeout(() => { this.dados = $(btn.currentTarget).data(); }, 10);
        });
        $('[btn-duplicar]').click((btn) => {
            this.dadosDuplicar = null;
            setTimeout(() => { this.dadosDuplicar = $(btn.currentTarget).data(); }, 10);
        });
        $('[btn-excluir]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
    }

    public aoDuplicado(novoId: any) {
        if (novoId) {
            this.$router.push({ name: 'sigap_turma_qts_gerador_qtssemanal_show', params: { id: this.turmaId, qtsSemanalId: novoId } });
        } else {
            this.reloadDatatable = !this.reloadDatatable;
        }
    }

    protected excluirModelo(id) {
        SiteUtils.alertConfimacao('Confirma a Exclusão', '',
            () => {
                this.processando = true;
                setTimeout(() => {
                    this.service.excluir(id)
                        .then(() => {
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusão realizada com sucesso!!');
                            this.processando = false;
                        })
                        .catch(error => {
                            this.processando = false;
                            SiteUtils.toastErro('Não foi possível Excluir', error?.data?.message);
                        });
                }, 10);
            }
        );
    }
}
</script>

<style scoped>
.qts-semanal-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}
</style>
